import React from "react";
import contextProvider from "../../contextProvider";
import Dropzone from "react-dropzone";
import DateRangePicker from "react-bootstrap-daterangepicker";

import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";

import Section from "app/_L1_components/Layout/Section";
import ReactOButton from "../Elements/ReactOButton";
import ReactODropdown from "../Elements/ReactODropdown";

import {
  FormGroup,
  Label,
  Input,
  CustomInput,
  FormFeedback,
  FormText,
  InputGroup,
  InputGroupAddon,
  ButtonGroup,
} from "reactstrap";

class ReactOFormInput extends _ReactOBaseComponent {
  constructor(props) {
    //	console.log("DEBUG :: ReactOFormInput _ constructor");
    var initState = {
      valid: true,
      uploadingFiles: [],
    };
    super(props, initState);
  }

  _makeid() {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    this._GENERATE_DATA_KEY = text;
    return text;
  }

  //
  //	Lifecycle methods
  //

  onComponentDidMount() {
    //	console.log("DEBUG :: ReactOFormInput _ onComponentDidMount");
    //	console.log(this.props);
    //	console.log(this.props.data_key);
    this.context.ReactOForm.registerInput({
      ...{
        ...this.props,
        ...(this.props.data_key === undefined
          ? { data_key: this._makeid(), auxiliary: true }
          : {}),

        ...(this.props.type == "array" && this.props.default === undefined
          ? { default: [""] }
          : {}),
        ...(this.props.type == "upload" && this.props.default === undefined
          ? { default: [] }
          : {}),
        ...(this.props.type == "upload" && this.props.auxiliary === undefined
          ? { auxiliary: this.props.onUpload !== undefined ? true : false }
          : {}),

        ...(/^(array|upload)$/.test(this.props.type) &&
        this.props.default === undefined
          ? { default: this.props.type == "array" ? [""] : [] }
          : {}),
        ...{
          validators: [
            ...(this.props.type == "password" && this.props.fake
              ? [
                  {
                    type: "bypass",
                    func: (value, form_data) => {
                      return !this._INPUT_PASSWORD_FIRST_CHANGE;
                    },
                  },
                ]
              : []),
            ...(this.props.required
              ? /(text|email|password)/.test(this.props.type)
                ? [
                    {
                      func: (value) => {
                        return value && /^.+$/.test(value);
                      },
                      invalid_text: "Field required",
                    },
                  ]
                : /checkbox/.test(this.props.type)
                  ? [
                      {
                        func: (value) => {
                          return value && /^on$/.test(value);
                        },
                        invalid_text: "Field required",
                      },
                    ]
                  : []
              : []),
            ...(this.props.type === "email"
              ? [
                  {
                    func: (value) => {
                      return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(
                        value,
                      );
                    },
                    invalid_text: "Type a valid email",
                  },
                ]
              : []),
            ...(this.props.validators || []),
            //	...(this.props.validators ? [{func: (value) => {return value !== undefined}, invalid_text: "Set a value"}] : []),
          ],
        },
      },
      ...{ _defined: false },
    });
  }

  onComponentWillUnmount() {
    //		console.log("DEBUG :: ReactOFormInput _ onComponentWillUnmount");
    //		console.log(this.props.data_key);
    // this.context.ReactOForm.destroyEntry(this._calculatedDataKey);
    // this.context.ReactOForm.unregisterInput(this._calculatedDataKey);
  }

  onRender() {
    if (!this.context.ReactOForm.isReady()) {
      return null;
    }
    this._calculatedDataKey = this.props.data_key || this._GENERATE_DATA_KEY;
    let _shouldBeDefined = this.context.ReactOForm.evaluateDefinition(
      this._calculatedDataKey,
    );
    if (_shouldBeDefined === true) {
      return this.props.type == "submit" ? (
        <ReactOButton
          onClick={(e) => {
            this.context.ReactOForm.submit();
          }}
          preventDefault
          color={this.props.color}
          size={this.props.size}
          icon={this.props.icon}
          disabled={this.context.ReactOForm.isDirty() || this.props.disabled}
          round={this.props.round}
          className={this.props.className}
          style={this.props.style}
        >
          {this.props.children || this.props.value}
        </ReactOButton>
      ) : this.props.type == "error_display" ? (
        <div className={this.props.className}>
          {this.props.render
            ? this.props.render(this.context.ReactOForm.getErrorMessage())
            : this.context.ReactOForm.getErrorMessage()}
        </div>
      ) : this.props.type != "hidden" &&
        (() => {
          if (this.props.showIf !== undefined) {
            return this.props.showIf(this.context.ReactOForm.getFormData());
          } else {
            return true;
          }
        })() ? (
        <FormGroup className={"mb-0 " + (this.props.className || "")}>
          {/* LABEL */}

          {((this.props.type == "checkbox" && this.props.description) ||
            this.props.type != "checkbox") &&
          this.props.type != "switch" &&
          this.props.label ? (
            <Label for={this._calculatedDataKey}>
              {typeof this.props.label == "function"
                ? this.props.label()
                : this.props.label}
            </Label>
          ) : null}

          {/* INPUTs */}

          {this.props.type == "text"
            ? (() => {
                let _input = (
                  <Input
                    className={
                      "form-input-text " + (this.props.inputClassName || "")
                    }
                    type={this.props.type}
                    name={this._calculatedDataKey}
                    id={this.props.inputId || this._calculatedDataKey}
                    innerRef={(DOMinput) => {
                      if (
                        this.props.autofocus &&
                        DOMinput &&
                        !this._FIRST_AUTOFOCUS_DONE
                      ) {
                        DOMinput.focus();
                        this._FIRST_AUTOFOCUS_DONE = true;
                      }
                    }}
                    bsSize={this.props.size}
                    placeholder={this.props.placeholder}
                    disabled={
                      (this.props.disabledIf
                        ? this.props.disabledIf(
                            this.context.ReactOForm.getFormData(true),
                          )
                        : false) || this.props.disabled
                    }
                    onKeyPress={(e) => {
                      if (e.key == "Enter") {
                        e.preventDefault();
                        e.stopPropagation();
                        if (this.context.ReactOForm.submitOnEnterKey()) {
                          this.context.ReactOForm.submit();
                        }
                      }
                    }}
                    onChange={
                      this.props.disabled === false ||
                      this.props.disabled === undefined
                        ? this.props.onValueChange
                          ? (e) => {
                              this.props.onValueChange(
                                this.context.ReactOForm,
                                e.target.value,
                              );
                            }
                          : (e) => {
                              this.context.ReactOForm.handleFormChange(
                                this._calculatedDataKey,
                                e.target.value,
                              );
                            }
                        : null
                    }
                    value={(() => {
                      let _value = this.context.ReactOForm.getEntry(
                        this._calculatedDataKey,
                      );
                      return _value !== undefined ? _value : "";
                    })()}
                    valid={this.context.ReactOForm.isValid(
                      this._calculatedDataKey,
                    )}
                    invalid={this.context.ReactOForm.isInvalid(
                      this._calculatedDataKey,
                    )}
                  />
                );
                _input =
                  this.props.append || this.props.prepend ? (
                    <InputGroup>
                      {this.props.prepend ? (
                        <InputGroupAddon addonType="prepend">
                          {this.props.prepend}
                        </InputGroupAddon>
                      ) : null}
                      {_input}
                      {this.props.append ? (
                        <InputGroupAddon addonType="append">
                          {this.props.append}
                        </InputGroupAddon>
                      ) : null}
                    </InputGroup>
                  ) : (
                    _input
                  );
                return this.props.render ? this.props.render(_input) : _input;
              })()
            : this.props.type == "textarea"
              ? (() => {
                  let _input = (
                    <Input
                      className={
                        "form-input-text " + (this.props.inputClassName || "")
                      }
                      type={this.props.type}
                      name={this._calculatedDataKey}
                      id={this.props.inputId || this._calculatedDataKey}
                      innerRef={(DOMinput) => {
                        if (
                          this.props.autofocus &&
                          DOMinput &&
                          !this._FIRST_AUTOFOCUS_DONE
                        ) {
                          DOMinput.focus();
                          this._FIRST_AUTOFOCUS_DONE = true;
                        }
                      }}
                      bsSize={this.props.size}
                      placeholder={this.props.placeholder}
                      disabled={
                        (this.props.disabledIf
                          ? this.props.disabledIf(
                              this.context.ReactOForm.getFormData(true),
                            )
                          : false) || this.props.disabled
                      }
                      // onKeyPress={(e) => {
                      //   if (e.key == "Enter") {
                      //     e.preventDefault();
                      //     e.stopPropagation();
                      //     if (this.context.ReactOForm.submitOnEnterKey()) {
                      //       this.context.ReactOForm.submit();
                      //     }
                      //   }
                      // }}
                      onChange={
                        this.props.disabled === false ||
                        this.props.disabled === undefined
                          ? this.props.onValueChange
                            ? (e) => {
                                this.props.onValueChange(
                                  this.context.ReactOForm,
                                  e.target.value,
                                );
                              }
                            : (e) => {
                                this.context.ReactOForm.handleFormChange(
                                  this._calculatedDataKey,
                                  e.target.value,
                                );
                              }
                          : null
                      }
                      value={
                        this.context.ReactOForm.getEntry(
                          this._calculatedDataKey,
                        ) || ""
                      }
                      valid={this.context.ReactOForm.isValid(
                        this._calculatedDataKey,
                      )}
                      invalid={this.context.ReactOForm.isInvalid(
                        this._calculatedDataKey,
                      )}
                    />
                  );
                  _input =
                    this.props.append || this.props.prepend ? (
                      <InputGroup>
                        {this.props.prepend ? (
                          <InputGroupAddon addonType="prepend">
                            {this.props.prepend}
                          </InputGroupAddon>
                        ) : null}
                        {_input}
                        {this.props.append ? (
                          <InputGroupAddon addonType="append">
                            {this.props.append}
                          </InputGroupAddon>
                        ) : null}
                      </InputGroup>
                    ) : (
                      _input
                    );
                  return this.props.render ? this.props.render(_input) : _input;
                })()
              : this.props.type == "password"
                ? (() => {
                    let _input = (
                      <Input
                        className={
                          "form-input-password" +
                          (!this.state._INPUT_PASSWORD_VISIBLE
                            ? " hide-pwd "
                            : "") +
                          (this.props.inputClassName || "")
                        }
                        type={
                          this.props.realPwd
                            ? "password"
                            : this.getAppContext().isBrowserEdge() ||
                                this.getAppContext().isBrowserIE11() ||
                                this.getAppContext().isBrowserFirefox()
                              ? !this.state._INPUT_PASSWORD_VISIBLE
                                ? "password"
                                : "text"
                              : "text"
                        }
                        name={this._calculatedDataKey}
                        innerRef={(DOMinput) => {
                          if (DOMinput) {
                            DOMinput.autocomplete = "off";
                          }
                          if (
                            this.props.autofocus &&
                            DOMinput &&
                            !this._FIRST_AUTOFOCUS_DONE
                          ) {
                            DOMinput.focus();
                            this._FIRST_AUTOFOCUS_DONE = true;
                          }
                        }}
                        bsSize={this.props.size}
                        placeholder={this.props.placeholder}
                        disabled={this.props.disabled}
                        onPaste={
                          this.props.preventPaste
                            ? (e) => {
                                e.preventDefault();
                              }
                            : null
                        }
                        onCopy={
                          this.props.preventCopyCut
                            ? (e) => {
                                e.preventDefault();
                              }
                            : null
                        }
                        onCut={
                          this.props.preventCopyCut
                            ? (e) => {
                                e.preventDefault();
                              }
                            : null
                        }
                        onKeyPress={(e) => {
                          if (e.key == "Enter") {
                            e.preventDefault();
                            e.stopPropagation();
                            if (this.context.ReactOForm.submitOnEnterKey()) {
                              this.context.ReactOForm.submit();
                            }
                          }
                        }}
                        onChange={
                          this.props.disabled === false ||
                          this.props.disabled === undefined
                            ? this.props.onValueChange
                              ? (e) => {
                                  this.props.onValueChange(
                                    this.context.ReactOForm,
                                    (() => {
                                      if (
                                        this.props.fake &&
                                        !this._INPUT_PASSWORD_FIRST_CHANGE
                                      ) {
                                        let _first_value =
                                          e.target.value.replace(/¢/g, "");
                                        this._INPUT_PASSWORD_FIRST_CHANGE = true;
                                        return _first_value;
                                      } else {
                                        if (!this.props._mock_) {
                                          this.context.ReactOForm.setEntry(
                                            this._calculatedDataKey + "_l",
                                            e.target.value.length,
                                          );
                                        }
                                        return e.target.value;
                                      }
                                    })(),
                                  );
                                }
                              : (e) => {
                                  this.context.ReactOForm.handleFormChange(
                                    this._calculatedDataKey,
                                    (() => {
                                      if (
                                        this.props.fake &&
                                        !this._INPUT_PASSWORD_FIRST_CHANGE
                                      ) {
                                        let _first_value =
                                          e.target.value.replace(/¢/g, "");
                                        this._INPUT_PASSWORD_FIRST_CHANGE = true;
                                        return _first_value;
                                      } else {
                                        if (!this.props._mock_) {
                                          this.context.ReactOForm.setEntry(
                                            this._calculatedDataKey + "_l",
                                            e.target.value.length,
                                          );
                                        }
                                        return e.target.value;
                                      }
                                    })(),
                                  );
                                }
                            : null
                        }
                        value={
                          this.props.fake && !this._INPUT_PASSWORD_FIRST_CHANGE
                            ? (() => {
                                return new Array(
                                  (() => {
                                    let _TMP_l_value = parseInt(
                                      this.context.ReactOForm.getEntry(
                                        this._calculatedDataKey + "_l",
                                      ),
                                    );
                                    return _TMP_l_value && _TMP_l_value > 0
                                      ? _TMP_l_value
                                      : -1;
                                  })() + 1,
                                ).join("¢");
                              })()
                            : this.context.ReactOForm.getEntry(
                                this._calculatedDataKey,
                              ) || ""
                        }
                        valid={this.context.ReactOForm.isValid(
                          this._calculatedDataKey,
                        )}
                        invalid={this.context.ReactOForm.isInvalid(
                          this._calculatedDataKey,
                        )}
                      />
                    );
                    _input =
                      this.props.append ||
                      this.props.prepend ||
                      this.props.watchable ? (
                        <InputGroup>
                          {this.props.prepend ? (
                            <InputGroupAddon addonType="prepend">
                              {this.props.prepend}
                            </InputGroupAddon>
                          ) : null}
                          {_input}
                          {this.props.watchable ? (
                            <InputGroupAddon addonType="append">
                              <ReactOButton
                                title={
                                  this.state._INPUT_PASSWORD_VISIBLE
                                    ? "Hide password"
                                    : "Show password"
                                }
                                icon={
                                  this.state._INPUT_PASSWORD_VISIBLE
                                    ? "eye-off"
                                    : "eye-on"
                                }
                                size={this.props.size}
                                disabled={
                                  this.props.fake &&
                                  !this._INPUT_PASSWORD_FIRST_CHANGE
                                }
                                preventDefault
                                onClick={() => {
                                  this.setState((prev_state) => {
                                    prev_state._INPUT_PASSWORD_VISIBLE =
                                      !prev_state._INPUT_PASSWORD_VISIBLE;
                                    return prev_state;
                                  });
                                }}
                              />
                            </InputGroupAddon>
                          ) : null}
                          {this.props.append ? (
                            <InputGroupAddon addonType="append">
                              {this.props.append}
                            </InputGroupAddon>
                          ) : null}
                        </InputGroup>
                      ) : (
                        _input
                      );
                    return _input;
                  })()
                : this.props.type == "select"
                  ? (() => {
                      let _validation_result =
                        this.context.ReactOForm.getValidationResult(
                          this._calculatedDataKey,
                        );
                      return (
                        <div
                          className={
                            "select-control" +
                            (_validation_result
                              ? _validation_result.result === true
                                ? " is-valid"
                                : _validation_result.result === false
                                  ? " is-invalid"
                                  : ""
                              : "")
                          }
                        >
                          <ReactODropdown
                            className={
                              "form-input-select " +
                              (this.props.inputClassName || "")
                            }
                            scrollable={this.props.scrollable}
                            size={this.props.size}
                            color={this.props.color || "white"}
                            outline={this.props.outline || false}
                            onOpen={this.props.onOpen}
                            disabled={
                              (this.props.disabledIf
                                ? this.props.disabledIf(
                                    this.context.ReactOForm.getFormData(true),
                                  )
                                : false) || this.props.disabled
                            }
                            default={
                              this.props.default
                                ? typeof this.props.default == "function"
                                  ? this.props.default(
                                      this.context.ReactOForm.getFormData(true),
                                    )
                                  : this.props.default
                                : false
                            }
                            loadingPlug={this.props.loadingPlug}
                            toggler={() => {
                              return (
                                <span>
                                  {this.context.ReactOForm.getEntry(
                                    this._calculatedDataKey,
                                  ) !== undefined
                                    ? // this.props.customLabel != false
                                      //   ? this.props.customLabel
                                      //   :
                                      (() => {
                                        let _opt = (typeof this.props.options ==
                                        "function"
                                          ? this.props.options(
                                              this.context.ReactOForm.getFormData(
                                                true,
                                              ),
                                            )
                                          : this.props.options
                                        )
                                          .filter((value) => {
                                            return value && value !== null;
                                          })
                                          .find((_CURR_opt) => {
                                            let entry_value =
                                              this.context.ReactOForm.getEntry(
                                                this._calculatedDataKey,
                                              );
                                            return _CURR_opt.active &&
                                              _CURR_opt.active instanceof RegExp
                                              ? _CURR_opt.active.test(
                                                  entry_value,
                                                )
                                              : _CURR_opt.active &&
                                                  typeof _CURR_opt.active ==
                                                    "function"
                                                ? _CURR_opt.active(entry_value)
                                                : entry_value ==
                                                  (typeof _CURR_opt.value ==
                                                  "object"
                                                    ? _CURR_opt.value[
                                                        this._calculatedDataKey
                                                      ]
                                                    : typeof _CURR_opt.value ==
                                                        "function"
                                                      ? _CURR_opt.value(
                                                          this.context
                                                            .ReactOForm,
                                                        )
                                                      : _CURR_opt.value);
                                          }) || {
                                          name: this.props.noSelectionLabel
                                            ? this.props.noSelectionLabel
                                            : "Select one option...",
                                        };
                                        return _opt.name;
                                      })()
                                    : this.props.noSelectionLabel
                                      ? this.props.noSelectionLabel
                                      : "Select one option..."}
                                </span>
                              );
                            }}
                            options={(typeof this.props.options == "function"
                              ? this.props.options(
                                  this.context.ReactOForm.getFormData(true),
                                )
                              : this.props.options
                            )
                              .filter((value) => {
                                return value && value !== null;
                              })
                              .map((_CURR_opt, _CURR_idx) => {
                                return typeof _CURR_opt == "object"
                                  ? (() => {
                                      return {
                                        active: (() => {
                                          let entry_value =
                                            this.context.ReactOForm.getEntry(
                                              this._calculatedDataKey,
                                            );
                                          return _CURR_opt.active
                                            ? _CURR_opt.active instanceof RegExp
                                              ? _CURR_opt.active.test(
                                                  entry_value,
                                                )
                                              : typeof _CURR_opt.active ==
                                                  "function"
                                                ? _CURR_opt.active(entry_value)
                                                : false
                                            : entry_value ==
                                                (typeof _CURR_opt.value ==
                                                "object"
                                                  ? _CURR_opt.value[
                                                      this._calculatedDataKey
                                                    ]
                                                  : typeof _CURR_opt.value ==
                                                      "function"
                                                    ? _CURR_opt.value(
                                                        this.context.ReactOForm,
                                                      )
                                                    : _CURR_opt.value);
                                        })(),
                                        render: _CURR_opt.render,
                                        disabled: _CURR_opt.disabled,
                                        name: _CURR_opt.name,
                                        onClick: this.props.onOptionSelect
                                          ? () => {
                                              this.props.onOptionSelect(
                                                this.context.ReactOForm,
                                                typeof _CURR_opt.value ==
                                                  "function"
                                                  ? _CURR_opt.value(
                                                      this.context.ReactOForm,
                                                    )
                                                  : _CURR_opt.value,
                                                // _CURR_opt.name
                                              );
                                            }
                                          : (e) => {
                                              this.context.ReactOForm.handleFormChange(
                                                this._calculatedDataKey,
                                                typeof _CURR_opt.value ==
                                                  "function"
                                                  ? _CURR_opt.value(
                                                      this.context.ReactOForm,
                                                    )
                                                  : _CURR_opt.value,
                                                // _CURR_opt.name
                                              );
                                            },
                                      };
                                    })()
                                  : _CURR_opt;
                              })}
                          />
                        </div>
                      );
                    })()
                  : this.props.type == "email"
                    ? (() => {
                        let _input = (
                          <Input
                            className={
                              "form-input-email" +
                              (this.props.inputClassName || "")
                            }
                            type={this.props.type}
                            name={this._calculatedDataKey}
                            id={this.props.inputId || this._calculatedDataKey}
                            innerRef={(DOMinput) => {
                              if (
                                this.props.autofocus &&
                                DOMinput &&
                                !this._FIRST_AUTOFOCUS_DONE
                              ) {
                                DOMinput.focus();
                                this._FIRST_AUTOFOCUS_DONE = true;
                              } else if (!DOMinput) {
                                this._FIRST_AUTOFOCUS_DONE = false;
                              }
                            }}
                            bsSize={this.props.size}
                            placeholder={this.props.placeholder}
                            disabled={this.props.disabled}
                            onChange={
                              this.props.disabled === false ||
                              this.props.disabled === undefined
                                ? this.props.onValueChange
                                  ? (e) => {
                                      this.props.onValueChange(
                                        this.context.ReactOForm,
                                        e.target.value,
                                      );
                                    }
                                  : (e) => {
                                      this.context.ReactOForm.handleFormChange(
                                        this._calculatedDataKey,
                                        e.target.value,
                                      );
                                    }
                                : null
                            }
                            value={this.context.ReactOForm.getEntry(
                              this._calculatedDataKey,
                            )}
                            valid={this.context.ReactOForm.isValid(
                              this._calculatedDataKey,
                            )}
                            invalid={this.context.ReactOForm.isInvalid(
                              this._calculatedDataKey,
                            )}
                          />
                        );
                        _input =
                          this.props.append || this.props.prepend ? (
                            <InputGroup>
                              {this.props.prepend ? (
                                <InputGroupAddon addonType="prepend">
                                  {this.props.prepend}
                                </InputGroupAddon>
                              ) : null}
                              {_input}
                              {this.props.append ? (
                                <InputGroupAddon addonType="append">
                                  {this.props.append}
                                </InputGroupAddon>
                              ) : null}
                            </InputGroup>
                          ) : (
                            _input
                          );
                        return _input;
                      })()
                    : this.props.type == "checkbox"
                      ? (() => {
                          return (
                            <CustomInput
                              className={"" + (this.props.inputClassName || "")}
                              type={this.props.type}
                              name={this._calculatedDataKey}
                              id={this._calculatedDataKey}
                              label={this.props.description || this.props.label}
                              bsSize={this.props.size}
                              placeholder={this.props.placeholder}
                              disabled={this.props.disabled}
                              onClick={
                                this.props.onClick
                                  ? (e) => {
                                      this.props.onClick(e);
                                    }
                                  : null
                              }
                              onChange={
                                this.props.disabled === false ||
                                this.props.disabled === undefined
                                  ? (e) => {
                                      this.context.ReactOForm.handleFormChange(
                                        this._calculatedDataKey,
                                        e.target.checked
                                          ? this.props.switchOnValue !==
                                            undefined
                                            ? this.props.switchOnValue
                                            : "on"
                                          : this.props.switchOffValue !==
                                              undefined
                                            ? this.props.switchOffValue
                                            : "off",
                                      );
                                    }
                                  : null
                              }
                              checked={
                                this.context.ReactOForm.getEntry(
                                  this._calculatedDataKey,
                                ) ==
                                (this.props.switchOnValue !== undefined
                                  ? this.props.switchOnValue
                                  : "on")
                                  ? true
                                  : false
                              }
                              valid={this.context.ReactOForm.isValid(
                                this._calculatedDataKey,
                              )}
                              invalid={this.context.ReactOForm.isInvalid(
                                this._calculatedDataKey,
                              )}
                            />
                          );
                        })()
                      : this.props.type == "switch"
                        ? (() => {
                            return (
                              <CustomInput
                                className={
                                  "" + (this.props.inputClassName || "")
                                }
                                type={this.props.type}
                                name={this._calculatedDataKey}
                                id={this._calculatedDataKey}
                                label={
                                  this.props.description || this.props.label
                                }
                                bsSize={this.props.size}
                                placeholder={this.props.placeholder}
                                disabled={this.props.disabled}
                                onClick={
                                  this.props.onClick
                                    ? (e) => {
                                        this.props.onClick(e);
                                      }
                                    : null
                                }
                                onChange={
                                  this.props.disabled === false ||
                                  this.props.disabled === undefined
                                    ? (e) => {
                                        this.context.ReactOForm.handleFormChange(
                                          this._calculatedDataKey,
                                          e.target.checked
                                            ? this.props.switchOnValue !==
                                              undefined
                                              ? this.props.switchOnValue
                                              : "on"
                                            : this.props.switchOffValue !==
                                                undefined
                                              ? this.props.switchOffValue
                                              : "off",
                                        );
                                      }
                                    : null
                                }
                                checked={
                                  this.context.ReactOForm.getEntry(
                                    this._calculatedDataKey,
                                  ) ==
                                  (this.props.switchOnValue !== undefined
                                    ? this.props.switchOnValue
                                    : "on")
                                    ? true
                                    : false
                                }
                                valid={this.context.ReactOForm.isValid(
                                  this._calculatedDataKey,
                                )}
                                invalid={this.context.ReactOForm.isInvalid(
                                  this._calculatedDataKey,
                                )}
                              />
                            );
                          })()
                        : this.props.type == "array"
                          ? (() => {
                              return (
                                <div
                                  className={
                                    "form-input-array " +
                                    (this.props.inputClassName || "")
                                  }
                                >
                                  {React.Children.map(
                                    this.props.onRender(
                                      (() => {
                                        let _data =
                                          this.context.ReactOForm.getEntry(
                                            this._calculatedDataKey,
                                          );
                                        if (!_data) return;
                                        if (Array.isArray(_data)) {
                                          return _data;
                                        } else {
                                          let _ret = [];
                                          Object.keys(_data).forEach(
                                            (_CURR_data, _CURR_idx) => {
                                              _ret.push({
                                                __id: _CURR_data,
                                                ..._data[_CURR_data],
                                              });
                                            },
                                          );
                                          return _ret;
                                        }
                                      })() || [""],
                                      (idx) => {
                                        this.context.ReactOForm.destroyEntry(
                                          this._calculatedDataKey + "." + idx,
                                        );
                                        let _registeredInputs =
                                          this.context.ReactOForm.getRegisteredInputs();

                                        let _current_data_keys = Object.keys(
                                          _registeredInputs,
                                        )
                                          .filter((_C_value) => {
                                            let re = new RegExp(
                                              "^" +
                                                this._calculatedDataKey +
                                                "\\.(\\d+).*",
                                            );
                                            let _TMP = re.exec(_C_value);
                                            return (
                                              _TMP && parseInt(_TMP[1]) >= idx
                                            );
                                          })
                                          .sort();
                                        _current_data_keys.forEach(
                                          (_C_entry, _C_idx) => {
                                            let re = new RegExp(
                                              "^" +
                                                this._calculatedDataKey +
                                                "\\.(\\d+)(.*)",
                                            );
                                            let _TMP = re.exec(_C_entry);
                                            if (parseInt(_TMP[1]) != idx) {
                                              let _TMP_reg_data =
                                                _registeredInputs[_C_entry];
                                              if (_TMP_reg_data.data_key) {
                                                _TMP_reg_data.data_key =
                                                  this._calculatedDataKey +
                                                  "." +
                                                  (parseInt(_TMP[1]) - 1) +
                                                  (_TMP[2] || "");
                                              }
                                              _registeredInputs[
                                                this._calculatedDataKey +
                                                  "." +
                                                  (parseInt(_TMP[1]) - 1) +
                                                  (_TMP[2] || "")
                                              ] = _TMP_reg_data;
                                            }
                                            delete _registeredInputs[_C_entry];
                                          },
                                        );
                                        this.forceUpdate();
                                      },
                                      () => {
                                        this.context.ReactOForm.setEntry(
                                          this._calculatedDataKey +
                                            "." +
                                            this.context.ReactOForm.getEntry(
                                              this._calculatedDataKey,
                                            ).length,
                                          "",
                                        );
                                        this.forceUpdate();
                                      },
                                    ),
                                    (_CURR_child, _CURR_idx) => {
                                      return React.cloneElement(_CURR_child, {
                                        key: _CURR_idx,
                                      });
                                    },
                                  )}
                                </div>
                              );
                            })()
                          : this.props.type == "radio-buttons"
                            ? (() => {
                                return (
                                  <div>
                                    <ButtonGroup
                                      className={
                                        this.props.justified ? "d-flex" : ""
                                      }
                                    >
                                      {(this.props.options || []).map(
                                        (_C_opt, _C_idx) => {
                                          let _is_selected =
                                            this.context.ReactOForm.getEntry(
                                              this._calculatedDataKey,
                                            ) == _C_opt.value;
                                          return (
                                            <ReactOButton
                                              key={_C_idx}
                                              className={
                                                (this.props.justified
                                                  ? "w-100"
                                                  : "") +
                                                (this.props.selectedColor &&
                                                !_is_selected
                                                  ? " border"
                                                  : "")
                                              }
                                              color={
                                                this.props.selectedColor
                                                  ? _is_selected
                                                    ? this.props.selectedColor
                                                    : "light"
                                                  : this.props.color
                                              }
                                              icon={_C_opt.icon}
                                              disabled={this.props.disabled}
                                              onClick={() => {
                                                if (
                                                  this.props.onOptionSelected
                                                ) {
                                                  this.props.onOptionSelected(
                                                    this.context.ReactOForm,
                                                    _C_opt.value,
                                                  );
                                                } else {
                                                  this.context.ReactOForm.handleFormChange(
                                                    this._calculatedDataKey,
                                                    _C_opt.value,
                                                  );
                                                }
                                              }}
                                              active={_is_selected}
                                            >
                                              {_C_opt.name}
                                            </ReactOButton>
                                          );
                                        },
                                      )}
                                    </ButtonGroup>
                                  </div>
                                );
                              })()
                            : this.props.type == "datetime-picker"
                              ? (() => {
                                  let _input = (
                                    <div>
                                      <DateRangePicker
                                        initialSettings={{
                                          startDate:
                                            this.getAppContext().momentjs(
                                              this.context.ReactOForm.getEntry(
                                                this._calculatedDataKey,
                                              ) ||
                                                this.getAppContext()
                                                  .momentjs()
                                                  .unix(),
                                              "X",
                                            ),
                                          autoApply: true,
                                          maxDate:
                                            this.getAppContext().momentjs(),
                                          singleDatePicker: true,
                                          timePicker: true,
                                          timePicker24Hour:
                                            this.getAppContext().momentjs.locale() ==
                                            "en"
                                              ? false
                                              : true,
                                          cancelClass: "btn btn-light",
                                          applyClass: "btn btn-primary",
                                        }}
                                        onHide={(event, picker) => {
                                          this._PREV_DATETIME_PICKER_VALUE =
                                            this.context.ReactOForm.getEntry(
                                              this._calculatedDataKey,
                                            );
                                          this.context.ReactOForm.handleFormChange(
                                            this._calculatedDataKey,
                                            picker.startDate.unix(),
                                          );
                                        }}
                                        onApply={(e, picker) => {}}
                                        onCancel={(e, picker) => {
                                          if (
                                            this._PREV_DATETIME_PICKER_VALUE
                                          ) {
                                            this.context.ReactOForm.handleFormChange(
                                              this._calculatedDataKey,
                                              this._PREV_DATETIME_PICKER_VALUE,
                                            );
                                          }
                                        }}
                                      >
                                        <button className="selected-date-range-btn text-nowrap nofocus btn btn-outline-secondary">
                                          <span
                                            className="icon-calendar"
                                            style={{ marginRight: "8px" }}
                                          />
                                          {this.getAppContext()
                                            .momentjs(
                                              this.context.ReactOForm.getEntry(
                                                "ts",
                                              ),
                                              "X",
                                            )
                                            .format("L LT")}
                                        </button>
                                      </DateRangePicker>
                                    </div>
                                  );
                                  _input =
                                    this.props.append || this.props.prepend ? (
                                      <InputGroup>
                                        {this.props.prepend ? (
                                          <InputGroupAddon addonType="prepend">
                                            {this.props.prepend}
                                          </InputGroupAddon>
                                        ) : null}
                                        {_input}
                                        {this.props.append ? (
                                          <InputGroupAddon addonType="append">
                                            {this.props.append}
                                          </InputGroupAddon>
                                        ) : null}
                                      </InputGroup>
                                    ) : (
                                      _input
                                    );
                                  return this.props.render
                                    ? this.props.render(_input)
                                    : _input;
                                })()
                              : this.props.type == "upload"
                                ? (() => {
                                    let _data =
                                      this.context.ReactOForm.getEntry(
                                        this._calculatedDataKey,
                                      );
                                    let _validation_result =
                                      this.context.ReactOForm.getValidationResult(
                                        this._calculatedDataKey,
                                      );
                                    return (
                                      <div
                                        className={
                                          "upload-control" +
                                          (_validation_result
                                            ? _validation_result.result === true
                                              ? " is-valid"
                                              : _validation_result.result ===
                                                  false
                                                ? " is-invalid"
                                                : ""
                                            : "")
                                        }
                                      >
                                        <Dropzone
                                          onDrop={(acceptedFiles) => {
                                            this.setState({
                                              loadingFileReader: true,
                                            });
                                            let _curr_unloading_queue =
                                              this.context.ReactOForm.getEntry(
                                                this._calculatedDataKey,
                                              );

                                            let _c = 0;
                                            Promise.all(
                                              (() => {
                                                let _filtered_list =
                                                  acceptedFiles.filter(
                                                    (_C_file) => {
                                                      return this.props.fileType
                                                        ? new RegExp(
                                                            "^" +
                                                              Object.keys(
                                                                this.props
                                                                  .fileType,
                                                              ).join("|") +
                                                              "$",
                                                          ).test(_C_file.type)
                                                        : true;
                                                    },
                                                  );
                                                _filtered_list.splice(
                                                  0,
                                                  this.props.maxUploads !==
                                                    undefined &&
                                                    _curr_unloading_queue.length +
                                                      _filtered_list.length >=
                                                      this.props.maxUploads
                                                    ? _filtered_list.length -
                                                        (this.props.maxUploads -
                                                          _curr_unloading_queue.length)
                                                    : 0,
                                                );
                                                return _filtered_list;
                                              })().map((_C_file) => {
                                                return new Promise(
                                                  (resolve, reject) => {
                                                    if (
                                                      this.props.maxUploads ===
                                                        undefined ||
                                                      (this.props.maxUploads !==
                                                        undefined &&
                                                        _curr_unloading_queue.length +
                                                          (_c + 1) <=
                                                          this.props.maxUploads)
                                                    ) {
                                                      (/AAAsample|BIASI/.test(
                                                        _C_file.name,
                                                      )
                                                        ? this.parseBinFile.bind(
                                                            this,
                                                          )
                                                        : this.parseFile.bind(
                                                            this,
                                                          ))(
                                                        _C_file,
                                                        (_C_parsed_file) => {
                                                          if (_C_parsed_file) {
                                                            //															console.log("Resolving for " + _C_parsed_file.filename);
                                                            //															console.log(_C_parsed_file);
                                                            resolve(
                                                              _C_parsed_file,
                                                            );
                                                          } else {
                                                            //															console.log("Rejecting for " + _C_parsed_file.filename);
                                                            reject();
                                                          }
                                                        },
                                                      );
                                                    }
                                                    _c = _c + 1;
                                                  },
                                                );
                                              }),
                                            )
                                              .then((values) => {
                                                //											console.log("PARSING DONE");
                                                //											console.log(values);
                                                //											console.log(_curr_unloading_queue);
                                                _curr_unloading_queue = [
                                                  ..._curr_unloading_queue,
                                                  ...values.filter((value) => {
                                                    return value.status == "ok";
                                                  }),
                                                ];
                                                //											console.log(_curr_unloading_queue);
                                                this.context.ReactOForm.handleFormChange(
                                                  this._calculatedDataKey,
                                                  _curr_unloading_queue,
                                                );
                                                //	this.context.ReactOForm.setEntry(this._calculatedDataKey + "." + (this.context.ReactOForm.getEntry(this._calculatedDataKey).length), _parsed_file);
                                                this.forceUpdate();
                                                if (this.props.onDropped) {
                                                  this.setState({
                                                    loadingOnDropped: true,
                                                  });
                                                  this.props.onDropped(
                                                    this.context.ReactOForm,
                                                    _curr_unloading_queue,
                                                    (_new_uploading_queue) => {
                                                      if (
                                                        _new_uploading_queue
                                                      ) {
                                                        this.context.ReactOForm.handleFormChange(
                                                          this
                                                            ._calculatedDataKey,
                                                          _new_uploading_queue,
                                                        );
                                                      }
                                                      this.setState({
                                                        loadingOnDropped: false,
                                                      });
                                                    },
                                                  );
                                                }
                                              })
                                              .finally(() => {
                                                //											console.log("FINALLY");
                                                this.setState({
                                                  loadingFileReader: false,
                                                });
                                              });

                                            //	acceptedFiles.forEach((file, idx) => {
                                            //		if (this.props.maxUploads !== undefined && this.state.uploadingFiles.length + (idx + 1) <= this.props.maxUploads) {
                                            //			let _parsed_file = this.parseFile(file, () => {
                                            //
                                            //			});
                                            //		}
                                            //	});
                                          }}
                                          disabled={
                                            this.props.maxUploads !==
                                              undefined &&
                                            _data.length >=
                                              this.props.maxUploads
                                          }
                                        >
                                          {({
                                            getRootProps,
                                            getInputProps,
                                          }) => {
                                            return _data.length > 0 ||
                                              this.props.maxUploads ===
                                                undefined ||
                                              (this.props.maxUploads !==
                                                undefined &&
                                                _data.length <
                                                  this.props.maxUploads) ? (
                                              <div
                                                className={
                                                  "dropzone" +
                                                  (_validation_result
                                                    ? _validation_result.result ===
                                                      true
                                                      ? " is-valid"
                                                      : _validation_result.result ===
                                                          false
                                                        ? " is-invalid"
                                                        : ""
                                                    : "")
                                                }
                                                {...getRootProps()}
                                              >
                                                <input {...getInputProps()} />

                                                {(() => {
                                                  return (
                                                    <_LoadingWrapper
                                                      minHeight
                                                      loadingPlug={
                                                        this.state
                                                          .loadingFileReader ||
                                                        this.state
                                                          .loadingOnDropped
                                                      }
                                                    >
                                                      <div>
                                                        {_data &&
                                                        _data.length ? (
                                                          <div className="pt-2 px-2 text-muted">
                                                            <small>
                                                              <strong>
                                                                UPLOADING QUEUE
                                                              </strong>
                                                            </small>
                                                          </div>
                                                        ) : null}
                                                        {this.props
                                                          .queueRenderFunction ? (
                                                          <div
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                            }}
                                                          >
                                                            {this.props.queueRenderFunction(
                                                              _data,
                                                              (idx) => {
                                                                this.context.ReactOForm.setEntry(
                                                                  this
                                                                    ._calculatedDataKey +
                                                                    "." +
                                                                    idx,
                                                                  false,
                                                                );
                                                                this.context.ReactOForm.validate(
                                                                  this
                                                                    ._calculatedDataKey,
                                                                );
                                                                this.forceUpdate();
                                                              },
                                                            )}
                                                          </div>
                                                        ) : null}
                                                        {!this.props
                                                          .queueRenderFunction &&
                                                        _data &&
                                                        _data.length ? (
                                                          <Section
                                                            className="p-2"
                                                            designType="wide"
                                                            layoutManager="grid"
                                                            elementsPerRow={12}
                                                            gridSpacing={10}
                                                          >
                                                            {_data.map(
                                                              (
                                                                _C_entry,
                                                                _C_index,
                                                              ) => {
                                                                return (
                                                                  <div
                                                                    key={
                                                                      _C_index
                                                                    }
                                                                    className="queued-file"
                                                                    style={{
                                                                      position:
                                                                        "relative",
                                                                    }}
                                                                  >
                                                                    <div
                                                                      className={
                                                                        "bg-cover rounded oexif-correction-" +
                                                                        _C_entry.oexif
                                                                      }
                                                                      style={{
                                                                        position:
                                                                          "relative",
                                                                        zIndex:
                                                                          "1001",
                                                                        paddingBottom:
                                                                          "100%",
                                                                        background:
                                                                          "url(" +
                                                                          _C_entry.content +
                                                                          ") no-repeat center center",
                                                                      }}
                                                                    />
                                                                    <div
                                                                      style={{
                                                                        position:
                                                                          "absolute",
                                                                        top: "0",
                                                                        bottom:
                                                                          "0",
                                                                        width:
                                                                          "100%",
                                                                        zIndex:
                                                                          "1002",
                                                                      }}
                                                                    >
                                                                      <ReactOButton
                                                                        straight
                                                                        icon="cancel"
                                                                        color="light"
                                                                        size="sm"
                                                                        onClick={(
                                                                          e,
                                                                        ) => {
                                                                          e.stopPropagation();
                                                                          this.context.ReactOForm.setEntry(
                                                                            this
                                                                              ._calculatedDataKey +
                                                                              "." +
                                                                              _C_index,
                                                                            false,
                                                                          );
                                                                          this.context.ReactOForm.validate(
                                                                            this
                                                                              ._calculatedDataKey,
                                                                          );
                                                                          this.forceUpdate();
                                                                        }}
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                );
                                                              },
                                                            )}
                                                          </Section>
                                                        ) : null}
                                                      </div>

                                                      {this.props.maxUploads ===
                                                        undefined ||
                                                      (this.props.maxUploads !==
                                                        undefined &&
                                                        _data.length <
                                                          this.props
                                                            .maxUploads) ? (
                                                        <div
                                                          className="content-container text-truncate d-flex align-items-center justify-content-center"
                                                          style={{
                                                            padding: "0 20px",
                                                          }}
                                                        >
                                                          <span className="icon-plus-big mr-2 " />
                                                          <strong className="">
                                                            Drop here or click
                                                            this area to load
                                                            new files
                                                          </strong>
                                                        </div>
                                                      ) : null}
                                                    </_LoadingWrapper>
                                                  );
                                                })()}
                                              </div>
                                            ) : null;
                                          }}
                                        </Dropzone>
                                      </div>
                                    );
                                  })()
                                : this.props.type == "div"
                                  ? (() => {
                                      return (
                                        <div className={this.props.className}>
                                          {this.props.div_data}
                                        </div>
                                      );
                                    })()
                                  : null}

          {/* VALIDATION FEEDBACK */}

          {this.props.type != "submit"
            ? (() => {
                let _validation_result =
                  this.context.ReactOForm.getValidationResult(
                    this._calculatedDataKey,
                  );
                return [
                  _validation_result && _validation_result.result === true ? (
                    <FormFeedback key="0" valid>
                      {_validation_result.message}
                    </FormFeedback>
                  ) : null,
                  _validation_result && _validation_result.result === false ? (
                    <FormFeedback key="1">
                      {_validation_result.message}
                    </FormFeedback>
                  ) : null,
                ];
              })()
            : null}

          {/* HELP - this.context.ReactOForm.getFormData(true)*/}

          {this.props.help ? (
            <span
              style={this.props.modal ? { cursor: "pointer" } : {}}
              onClick={this.props.modal ? () => this.props.modal() : null}
            >
              <FormText color="muted" className="d-flex align-items-start">
                <span className="icon-info mr-1" style={{ fontSize: "130%" }} />
                {typeof this.props.help == "function"
                  ? this.props.help(this.context.ReactOForm.getFormData(true))
                  : this.props.help}
              </FormText>
            </span>
          ) : null}
        </FormGroup>
      ) : null;
    } else if (_shouldBeDefined == "_NOT_REGISTERED_") {
      /**
				Se il ReactOFormInput non risulta ancora registrato al ReactOForm,
				forzo un update in modo da ri-renderizzare dopo che sia stata chiamata
				onComponentDidUpdate() e che quindi sia stata fatta la registrazione del ReactOFormInput al ReactOForm.
				(Vedi ReactOForm -> evaluateDefinition)
			*/
      this.forceUpdate();
      return null;
    } else {
      return null;
    }
  }

  parseBinFile(file, cb) {
    console.log("parseBinFile:");
    console.log(file);

    const reader = new FileReader();

    reader.onload = (readerEvent) => {
      let matrix_2402 = [];
      let matrix_5150 = [];
      let matrix_5470 = [];

      let buffer = readerEvent.target.result;

      //	Sweeping from 2402 MHz to 2502 MHz	100		20
      //	Sweeping from 5150 MHz to 5350 MHz	200		40
      //	Sweeping from 5470 MHz to 5850 MHz	380		76

      console.log(buffer);

      //	let splitBitsBuffer = buffer.slice(0, 4);
      let int8View = new Uint8Array(buffer);

      console.log(int8View);

      let _C = 1;
      for (let i = 0; i < int8View.length; ) {
        if (
          int8View[i] == 0 &&
          int8View[i + 1] == 0 &&
          int8View[i + 2] == 0 &&
          int8View[i + 3] == 0 &&
          int8View[i + 4] != 0
        ) {
          let ts_1byte = int8View[i + 7].toString(16);
          let ts_2byte = int8View[i + 6].toString(16);
          let ts_3byte = int8View[i + 5].toString(16);
          let ts_4byte = int8View[i + 4].toString(16);
          ts_4byte = ts_4byte.length == 1 ? "0" + ts_4byte : ts_4byte;
          let timestamp = parseInt(
            ts_1byte + ts_2byte + ts_3byte + ts_4byte,
            16,
          );
          console.log(
            _C +
              ". " +
              timestamp +
              " | " +
              ts_1byte +
              ts_2byte +
              ts_3byte +
              ts_4byte +
              " | " +
              int8View[i + 7] +
              " " +
              int8View[i + 6] +
              " " +
              int8View[i + 5] +
              " " +
              int8View[i + 4] +
              " ___ " +
              (i + 4),
          );
          _C++;
          i = i + 8;
        } else {
          matrix_2402.push(int8View.slice(i, i + 20));
          matrix_5150.push(int8View.slice(i + 20, i + 60));
          matrix_5470.push(int8View.slice(i + 60, i + 136));
          i = i + 137;
        }
      }
      console.log(matrix_2402);
      console.log(matrix_5150);
      console.log(matrix_5470);

      /*
			let _C_row = [];
			int8View.forEach((_C_byte, _C_idx) => {
				
				console.log(_C_byte.toString(16));
				
				if (_C_byte == 0) {
					
				}
				
				
				let n1 = _C_byte >> 4;
				let n2 = _C_byte& 0xF;
			//	console.log("byte " + _C_idx + "        : " + _C_byte);
			//	console.log(".   nibble " + _C_idx + ".1: " + n1);
			//	console.log(".   nibble " + _C_idx + ".2: " + n2);
				if (_C_byte == 0) {
					matrix.push(_C_row);
					_C_row = [];
				} else {
					_C_row.push(n1, n2);
				}
				
			});
			*/
      //console.log("MATRIX");
      //console.log(matrix);
      //console.log(matrix.length);

      if (cb) {
        //			console.log("Calling cb...");
        cb({
          status: "ok",
          type: file.type,
          filename: file.name,
          content: {
            matrix_2402: matrix_2402,
            matrix_5150: matrix_5150,
            matrix_5470: matrix_5470,
          },
        });
      }
    };
    reader.onabort = () => {
      console.log("file reading was aborted");
      if (cb) cb({ status: "aborted", filename: file.name });
    };
    reader.onerror = () => {
      console.log("file reading has failed");
      if (cb) cb({ status: "failed", filename: file.name });
    };
    reader.readAsArrayBuffer(file);
  }

  //* UPLOAD FUNCTIONS */

  parseFile(file, cb) {
    if (this.props.fileTypes === undefined || this.props.fileTypes[file.type]) {
      const reader = new FileReader();
      reader.onload = (readerEvent) => {
        let acceptableFileTypeDefinition = this.props.fileTypes
          ? this.props.fileTypes[file.type] || {}
          : {};
        if (acceptableFileTypeDefinition.parsing_function) {
          acceptableFileTypeDefinition.parsing_function(reader.result, cb);
        } else if (file.type == "image/jpeg") {
          if (!this.EXIF_UTILS) {
            this.EXIF_UTILS = new ExifUtils();
          }
          const imageAsDataUrl = reader.result;

          // -------------------------------------------------------
          var image = new Image();
          var imageThumbAsDataUrl;
          var imageFullAsDataUrl;
          image.onload = (imageEvent) => {
            var oexif = this.EXIF_UTILS.getOExif(imageAsDataUrl);

            imageFullAsDataUrl = this.fixImageRotationAndScale(
              image,
              oexif,
              800,
            );
            imageThumbAsDataUrl = this.fixImageRotationAndScale(
              image,
              oexif,
              400,
            );

            if (cb) {
              //						console.log("Calling cb...");
              cb({
                status: "ok",
                type: file.type,
                filename: file.name,
                content: imageFullAsDataUrl,
                content_thumb: imageThumbAsDataUrl,
                //	oexif: oexif
              });
            }
          };
          image.src = readerEvent.target.result;
          // -------------------------------------------------------
        } else {
          if (cb) {
            //						console.log("Calling cb...");
            cb({
              status: "ok",
              type: file.type,
              filename: file.name,
              content: reader.result,
            });
          }
        }
      };
      reader.onabort = () => {
        console.log("file reading was aborted");
        if (cb) cb({ status: "aborted", filename: file.name });
      };
      reader.onerror = () => {
        console.log("file reading has failed");
        if (cb) cb({ status: "failed", filename: file.name });
      };
      reader.readAsDataURL(file);
    } else {
      console.log("Invalid file " + file.name + " (type: " + file.type + ")");
      if (cb) {
        cb({
          status: "invalid",
          filename: file.name,
        });
      }
    }
  }

  fixImageRotationAndScale(image, oexif, maxSize) {
    var canvas = document.createElement("canvas"),
      width = image.width,
      height = image.height;
    if (width > height) {
      if (width > maxSize) {
        height *= maxSize / width;
        width = maxSize;
      }
    } else {
      if (height > maxSize) {
        width *= maxSize / height;
        height = maxSize;
      }
    }
    if (oexif == 6) {
      canvas.width = height;
      canvas.height = width;
    } else {
      canvas.width = width;
      canvas.height = height;
    }
    canvas
      .getContext("2d")
      .rotate(((oexif == 3 ? 180 : oexif == 6 ? 90 : 0) * Math.PI) / 180);
    if (oexif == 3) {
      canvas.getContext("2d").translate(width * -1, height * -1);
    } else if (oexif == 6) {
      canvas.getContext("2d").translate(0, -height);
    }
    canvas.getContext("2d").drawImage(image, 0, 0, width, height);
    return canvas.toDataURL("image/jpeg");
  }
}

class ExifUtils {
  constructor() {
    this.KEY_STR =
      "ABCDEFGHIJKLMNOP" +
      "QRSTUVWXYZabcdef" +
      "ghijklmnopqrstuv" +
      "wxyz0123456789+/" +
      "=";
  }

  encode64(input) {
    var output = "",
      chr1,
      chr2,
      chr3 = "",
      enc1,
      enc2,
      enc3,
      enc4 = "",
      i = 0;

    do {
      chr1 = input[i++];
      chr2 = input[i++];
      chr3 = input[i++];

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output =
        output +
        this.KEY_STR.charAt(enc1) +
        this.KEY_STR.charAt(enc2) +
        this.KEY_STR.charAt(enc3) +
        this.KEY_STR.charAt(enc4);
      chr1 = chr2 = chr3 = "";
      enc1 = enc2 = enc3 = enc4 = "";
    } while (i < input.length);

    return output;
  }

  getOExif(origFileBase64) {
    var oexif = 1;
    if (!origFileBase64.match("data:image/jpeg;base64,")) {
      return oexif;
    }
    var rawImage = this.decode64(origFileBase64.split(",")[1]);

    var len = rawImage.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = rawImage[i];
    }

    var view = new DataView(bytes.buffer);
    if (view.getUint16(0, false) != 0xffd8) {
      return oexif;
    }
    var length = view.byteLength,
      offset = 2;
    while (offset < length) {
      if (view.getUint16(offset + 2, false) <= 8) {
        return oexif;
      }
      var marker = view.getUint16(offset, false);
      offset += 2;
      if (marker == 0xffe1) {
        if (view.getUint32((offset += 2), false) != 0x45786966) {
          return oexif;
        }

        var little = view.getUint16((offset += 6), false) == 0x4949;
        offset += view.getUint32(offset + 4, little);
        var tags = view.getUint16(offset, little);
        offset += 2;
        for (let i = 0; i < tags; i++) {
          if (view.getUint16(offset + i * 12, little) == 0x0112) {
            oexif = view.getUint16(offset + i * 12 + 8, little);
          }
        }
      } else if ((marker & 0xff00) != 0xff00) {
        break;
      } else {
        offset += view.getUint16(offset, false);
      }
    }
    return oexif;
  }

  restoreAndGetOExif(origFileBase64, resizedFileBase64) {
    if (!origFileBase64.match("data:image/jpeg;base64,")) {
      return resizedFileBase64;
    }
    var rawImage = this.decode64(origFileBase64.split(",")[1]);
    var segments = this.slice2Segments(rawImage);

    var image = this.exifManipulation(resizedFileBase64, segments);

    return origFileBase64.split(",")[0] + "," + this.encode64(image);
  }

  exifManipulation(resizedFileBase64, segments) {
    var exifArray = this.getExifArray(segments);

    var newImageArray = this.insertExif(resizedFileBase64, exifArray);
    var aBuffer = new Uint8Array(newImageArray);

    return aBuffer;
  }

  getExifArray(segments) {
    var seg;
    for (var x = 0; x < segments.length; x++) {
      seg = segments[x];
      if ((seg[0] == 255) & (seg[1] == 225)) {
        //(ff e1)
        return seg;
      }
    }
    return [];
  }

  insertExif(resizedFileBase64, exifArray) {
    var imageData = resizedFileBase64.split(",")[1],
      buf = this.decode64(imageData),
      separatePoint = buf.indexOf(255, 3),
      mae = buf.slice(0, separatePoint),
      ato = buf.slice(separatePoint),
      array = mae;

    array = array.concat(exifArray);
    array = array.concat(ato);
    return array;
  }

  slice2Segments(rawImageArray) {
    var head = 0,
      segments = [];

    while (1) {
      if ((rawImageArray[head] == 255) & (rawImageArray[head + 1] == 218)) {
        break;
      }
      if ((rawImageArray[head] == 255) & (rawImageArray[head + 1] == 216)) {
        head += 2;
      } else {
        var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
          endPoint = head + length + 2,
          seg = rawImageArray.slice(head, endPoint);
        segments.push(seg);
        head = endPoint;
      }
      if (head > rawImageArray.length) {
        break;
      }
    }

    return segments;
  }

  decode64(input) {
    var chr1,
      chr2,
      chr3 = "",
      enc1,
      enc2,
      enc3,
      enc4 = "",
      i = 0,
      buf = [];

    // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
    var base64test = /[^A-Za-z0-9\+\/\=]/g;
    if (base64test.exec(input)) {
      console.error(
        "There were invalid base64 characters in the input text.\n" +
          "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
          "Expect errors in decoding.",
      );
    }
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    do {
      enc1 = this.KEY_STR.indexOf(input.charAt(i++));
      enc2 = this.KEY_STR.indexOf(input.charAt(i++));
      enc3 = this.KEY_STR.indexOf(input.charAt(i++));
      enc4 = this.KEY_STR.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;

      buf.push(chr1);

      if (enc3 != 64) {
        buf.push(chr2);
      }
      if (enc4 != 64) {
        buf.push(chr3);
      }

      chr1 = chr2 = chr3 = "";
      enc1 = enc2 = enc3 = enc4 = "";
    } while (i < input.length);

    return buf;
  }
}

export default contextProvider(ReactOFormInput, {
  retrieve: ["ReactOForm"],
});
